import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "apRadio" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: _ctx.id,
      class: "apRadio__input",
      name: "radio",
      type: "radio",
      checked: _ctx.checked
    }, null, 8, _hoisted_2),
    _createElementVNode("label", {
      for: _ctx.id,
      class: "apRadio__label"
    }, _toDisplayString(_ctx.text), 9, _hoisted_3)
  ]))
}